<!--
  This is the baseclass of a view.

  This class preforms the followings:
  This class has method to preload images and background images based on the current view
  It will take care of background video player
-->
<template></template>
<script>
  export default {
    data() {
      // console.log('base data');
      // This is trigger before mount, thus, we can prepare all the config.json data
      const name = this.$router.history.current.name;
      let configJSON =  window.configMgr.views[name].data;

      if (typeof configJSON === 'undefined') {
        configJSON = {};
      }
      // This name is assign based on the current route name and it will be used
      // for this class to create unique id for component in computed properties.
      configJSON.name = name;
      configJSON.hoverable = configJSON.hoverable || [];
      configJSON.preload = configJSON.preload || [];
      configJSON.prefetch = configJSON.prefetch || [];

      // default to not use endframe is -1
      configJSON.useEndFrameWithoutPlay = -1;
      return configJSON;
    },
    computed: {
      videoPlayerId() {
        return `${this.name}-videoPlayer`;
      },
      hoverableId() {
        return `${this.name}-hoverable`;
      },
      videoPlayerBackgroundId() {
        return `${this.name}-videoPlayerBackground`;
      },
    },
    created() {
      // console.log('created base');
    },
    mounted() {
      // console.log('base mounted');
      // debugger;

      // send the hoverable to upper layer, so if needed, it can be combined
      // this.$emit('hoverable-detected', this.hoverable);

      // this.$el.style.visibility = 'hidden';
      // This is to set the image and background for all img and div.background tag
      window.preloader.setImageSrc(
        document.querySelectorAll('.prefetch'),     // img.src element in template that require prefetch images
        document.querySelectorAll('.prefetch-bg'),  // div.style.background element require prefetch
      );
    },
    activated() {
      this.activated();
    },
    deactivated() {
      this.deactivated();
    },
    beforeRouteEnter(to, from, next) {
      // NOTE: MUST OVERRIDE IF WE HAVE IMAGE OR BACKGROUND TO PRELOAD
      // Preload defines all images and background required to be preloaded
      // for the current vue page.  As the dom is not created at this point,
      // thus we need to explicit pass the image/background src here for preload
      const preload = [
        // './static/images/ge_advantage_customer.jpg',
      ];
      window.preloader.preloadForView(to.name, next);
    },
    beforeRouteLeave(to, from, next) {
      // For background video component to clean up before leaving
      if (this.$refs[this.videoPlayerId]) {
        this.$refs[this.videoPlayerId].readyToLeave(next);
      } else {
        next();
      }
    },
    // AS BASE CLASS, IT CANNOT DEFINE METHODS, USE MIXINS
    methods: {
      activated() {
        console.log(`${this.name} is being activated`);
        // Play animation if there exists
        window.animations.play('mounted', this.animations);

        // update back link to the defined value in config.json
        if (typeof this.backLink !== 'undefined') {
          this.$emit('require-back-link', this.backLink);
        }

        // This will enable hoverable svg if it present
        // It must be called prior to vidoeplayer as video player will
        // disable svg if it is required to only enable svg after video
        // is played.
        if (this.$refs[this.hoverableId]) {
          // console.log(`Activating - Hoverable SVG ${name}`);
          this.$refs[this.hoverableId].setEnableSVG(true);
        }

        // For background video component to get ready before going in to route
        if (this.$refs[this.videoPlayerId]) {
          this.$refs[this.videoPlayerId].readyToGo();
        }
      },
      deactivated() {
        // debugger;
        if (this.$refs[this.hoverableId]) {
          // console.log(`Deactivating - Hoverable SVG ${this.name}`);
          this.$refs[this.hoverableId].setEnableSVG(false);
        }
        if (this.$refs[this.videoPlayerId]) {
          // debugger;
          if (typeof this.$refs[this.videoPlayerId].enableHoverableWhilePlaying === 'function') {
            this.$refs[this.videoPlayerId].enableHoverableWhilePlaying(false);
          }
          this.$refs[this.videoPlayerId].readyToLeave();
        }
      },
    },
  };

</script>

<style lang="css" rel="stylesheet/css" scoped>
  /*@import "./resources/assets/sass/variables";*/
</style>



// WEBPACK FOOTER //
// BaseViewPage.vue?55740f73